// === AVA DISABLE MOBILE PULL TO REFRESH START ===
// Prevent accidental mobile pull-down refresh from restarting Ava/conversation.
// This is frontend-only and does not touch Ava brain/API behavior.

declare global {
  interface Window {
    __avaPullToRefreshGuardInstalled?: boolean;
  }
}

export function installDisablePullToRefresh() {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  if (window.__avaPullToRefreshGuardInstalled) return;

  window.__avaPullToRefreshGuardInstalled = true;

  let startY = 0;
  let startX = 0;

  const getScrollableParent = (target: EventTarget | null): HTMLElement | null => {
    let el = target as HTMLElement | null;

    while (el && el !== document.body && el !== document.documentElement) {
      const style = window.getComputedStyle(el);
      const canScrollY =
        /(auto|scroll)/.test(style.overflowY) && el.scrollHeight > el.clientHeight;

      if (canScrollY) return el;
      el = el.parentElement;
    }

    return null;
  };

  document.addEventListener(
    "touchstart",
    (event) => {
      const touch = event.touches[0];
      if (!touch) return;

      startY = touch.clientY;
      startX = touch.clientX;
    },
    { passive: true }
  );

  document.addEventListener(
    "touchmove",
    (event) => {
      const touch = event.touches[0];
      if (!touch) return;

      const deltaY = touch.clientY - startY;
      const deltaX = touch.clientX - startX;

      // Let horizontal gestures behave normally.
      if (Math.abs(deltaX) > Math.abs(deltaY)) return;

      const scrollable = getScrollableParent(event.target);
      const rootTop =
        window.scrollY <= 0 ||
        document.documentElement.scrollTop <= 0 ||
        document.body.scrollTop <= 0;

      // Block only the dangerous top pull-down gesture.
      if (!scrollable && rootTop && deltaY > 8) {
        event.preventDefault();
        return;
      }

      if (scrollable && scrollable.scrollTop <= 0 && deltaY > 8) {
        event.preventDefault();
      }
    },
    { passive: false }
  );
}
// === AVA DISABLE MOBILE PULL TO REFRESH END ===
